import { COLUMN_ACCESSORS } from '../constants/table';

export const stopListColumnsConfigs = {
  [COLUMN_ACCESSORS.HIGH_VALUE]: { width: 20 },
  [COLUMN_ACCESSORS.SERVICE]: { width: 52 },
  [COLUMN_ACCESSORS.PARCELS_INFO]: { width: 20 },
  [COLUMN_ACCESSORS.PICKUP_KIND]: { width: 30 },
  [COLUMN_ACCESSORS.DISPLAY_NUMBER]: { width: 45, isSubheader: true },
  [COLUMN_ACCESSORS.PRIORITY]: { width: 59 },
  [COLUMN_ACCESSORS.TYPE]: { width: 46 },
  [COLUMN_ACCESSORS.ADDRESS]: { width: 371 },
  [COLUMN_ACCESSORS.MANIFEST_LOCATION]: { width: 112 },
  [COLUMN_ACCESSORS.POSTCODE]: { width: 71 },
  [COLUMN_ACCESSORS.RAG]: { width: 44 },
  [COLUMN_ACCESSORS.PARCELS]: { width: 61, isSubheader: true },
  [COLUMN_ACCESSORS.CAD]: { width: 42, isSubheader: true },
  [COLUMN_ACCESSORS.SMALLS]: { width: 57, isSubheader: true },
  [COLUMN_ACCESSORS.LOADED]: { width: 60, isSubheader: true },
  [COLUMN_ACCESSORS.STOP_TIME]: { width: 75 },
  [COLUMN_ACCESSORS.ETA]: { width: 47 },
  [COLUMN_ACCESSORS.OT]: { width: 47, isSubheader: true },
  [COLUMN_ACCESSORS.EXCEPTION]: { width: 73, isSubheader: true },
  [COLUMN_ACCESSORS.WINDOW]: { width: 77 },
  [COLUMN_ACCESSORS.NC]: { width: 44, isSubheader: true },
  [COLUMN_ACCESSORS.WEIGHT]: { width: 64, isSubheader: true },
  [COLUMN_ACCESSORS.CHUTE]: { width: 53 },
  [COLUMN_ACCESSORS.REQUESTS]: { width: 78, isSubheader: true },
};

export const stopParcelDetailsColumnsConfigs = {
  [COLUMN_ACCESSORS.HIGH_VALUE]: { width: 20 },
  [COLUMN_ACCESSORS.SERVICE]: { width: 45 },
  [COLUMN_ACCESSORS.PARCELS_INFO]: { width: 20 },
  [COLUMN_ACCESSORS.PRIORITY]: { width: 24 },
  [COLUMN_ACCESSORS.PARCEL_NUMBER]: { width: 130 },
  [COLUMN_ACCESSORS.ADDRESS]: { width: 500 },
  [COLUMN_ACCESSORS.MANIFEST_LOCATION]: { width: 60 },
  [COLUMN_ACCESSORS.KING]: { width: 23 },
  [COLUMN_ACCESSORS.CAD_SCANNED]: { width: 26 },
  [COLUMN_ACCESSORS.LOAD]: { width: 29 },
  [COLUMN_ACCESSORS.WINDOW]: { width: 80 },
  [COLUMN_ACCESSORS.TYPE]: { width: 120 },
  [COLUMN_ACCESSORS.WEIGHT]: { width: 50 },
  [COLUMN_ACCESSORS.CHUTE]: { width: 35 },
  [COLUMN_ACCESSORS.REQUESTS]: { width: 23 },
};

export const requestedParcelsColumnsConfigs = {
  [COLUMN_ACCESSORS.HIGH_VALUE]: { width: 20 },
  [COLUMN_ACCESSORS.REQUEST_TYPE]: { width: 45 },
  [COLUMN_ACCESSORS.SERVICE]: { width: 45 },
  [COLUMN_ACCESSORS.PARCEL_NUMBER]: { width: 130 },
  [COLUMN_ACCESSORS.ADDRESS]: { width: 380 },
  [COLUMN_ACCESSORS.MANIFEST_LOCATION]: { width: 60 },
  [COLUMN_ACCESSORS.CAD_SCANNED]: { width: 26 },
  [COLUMN_ACCESSORS.LOAD]: { width: 29 },
  [COLUMN_ACCESSORS.WINDOW]: { width: 80 },
  [COLUMN_ACCESSORS.CHUTE]: { width: 35 },
  [COLUMN_ACCESSORS.REQUEST_REASON]: { width: 130 },
};

export const requestedCollectionColumnsConfigs = {
  [COLUMN_ACCESSORS.REQUEST_TYPE]: { width: 45 },
  [COLUMN_ACCESSORS.TYPE_OF_COLLECTION]: { width: 130 },
  [COLUMN_ACCESSORS.ADDRESS]: { width: 380 },
  [COLUMN_ACCESSORS.POSTCODE]: { width: 95 },
  [COLUMN_ACCESSORS.WINDOW]: { width: 80 },
  [COLUMN_ACCESSORS.REQUEST_REASON]: { width: 130 },
};

export const pickupRequestColumnsConfigs = {
  [COLUMN_ACCESSORS.STOP_NUMBER]: { width: 45 },
  [COLUMN_ACCESSORS.ADDRESS]: { width: 380 },
  [COLUMN_ACCESSORS.MANIFEST_LOCATION]: { width: 60 },
  [COLUMN_ACCESSORS.POSTCODE]: { width: 80 },
  [COLUMN_ACCESSORS.PARCELS]: { width: 80 },
  [COLUMN_ACCESSORS.CAD]: { width: 45 },
  [COLUMN_ACCESSORS.STOP_TIME]: { width: 65 },
  [COLUMN_ACCESSORS.EXCEPTION]: { width: 80 },
  [COLUMN_ACCESSORS.WINDOW]: { width: 80 },
};

export const mergeStopsColumnsConfigs = {
  [COLUMN_ACCESSORS.HIGH_VALUE]: { width: 20 },
  [COLUMN_ACCESSORS.DISPLAY_NUMBER]: { width: 45 },
  [COLUMN_ACCESSORS.ADDRESS]: { width: 512 },
  [COLUMN_ACCESSORS.MANIFEST_LOCATION]: { width: 124 },
  [COLUMN_ACCESSORS.POSTCODE]: { width: 77 },
  [COLUMN_ACCESSORS.PARCELS]: { width: 60 },
  [COLUMN_ACCESSORS.CAD]: { width: 50 },
  [COLUMN_ACCESSORS.STOP_TIME]: { width: 75 },
  [COLUMN_ACCESSORS.ETA]: { width: 41 },
  [COLUMN_ACCESSORS.EXCEPTION]: { width: 73 },
  [COLUMN_ACCESSORS.WINDOW]: { width: 95 },
};

export const transferStopListColumnsConfigs = {
  [COLUMN_ACCESSORS.HIGH_VALUE]: { width: 20 },
  [COLUMN_ACCESSORS.DISPLAY_NUMBER]: { width: 45 },
  [COLUMN_ACCESSORS.TYPE]: { width: 75 },
  [COLUMN_ACCESSORS.ADDRESS]: { width: 367 },
  [COLUMN_ACCESSORS.MANIFEST_LOCATION]: { width: 124 },
  [COLUMN_ACCESSORS.POSTCODE]: { width: 77 },
  [COLUMN_ACCESSORS.PARCELS]: { width: 60 },
  [COLUMN_ACCESSORS.CAD]: { width: 50 },
  [COLUMN_ACCESSORS.LOADED]: { width: 70 },
  [COLUMN_ACCESSORS.STOP_TIME]: { width: 75 },
  [COLUMN_ACCESSORS.ETA]: { width: 41 },
  [COLUMN_ACCESSORS.EXCEPTION]: { width: 73 },
  [COLUMN_ACCESSORS.WINDOW]: { width: 95 },
};

export const transferParcelsColumnsConfigs = {
  [COLUMN_ACCESSORS.HIGH_VALUE]: { width: 20 },
  [COLUMN_ACCESSORS.PARCEL_NUMBER]: { width: 130 },
  [COLUMN_ACCESSORS.ADDRESS]: { width: 475 },
  [COLUMN_ACCESSORS.MANIFEST_LOCATION]: { width: 60 },
  [COLUMN_ACCESSORS.POSTCODE]: { width: 126 },
  [COLUMN_ACCESSORS.CAD_SCANNED]: { width: 50 },
  [COLUMN_ACCESSORS.LOAD]: { width: 50 },
  [COLUMN_ACCESSORS.WINDOW]: { width: 85 },
  [COLUMN_ACCESSORS.CHUTE]: { width: 50 },
};

export const splitStopColumnsConfigs = {
  [COLUMN_ACCESSORS.HIGH_VALUE]: { width: 20 },
  [COLUMN_ACCESSORS.PRIORITY]: { width: 45 },
  [COLUMN_ACCESSORS.PARCEL_NUMBER]: { width: 114 },
  [COLUMN_ACCESSORS.ADDRESS]: { width: 475 },
  [COLUMN_ACCESSORS.MANIFEST_LOCATION]: { width: 60 },
  [COLUMN_ACCESSORS.CAD_SCANNED]: { width: 60 },
  [COLUMN_ACCESSORS.LOAD]: { width: 89 },
  [COLUMN_ACCESSORS.WINDOW]: { width: 135 },
  [COLUMN_ACCESSORS.TYPE]: { width: 82 },
};
